import React, { useRef } from 'react'
import Dropzone, { DropzoneRef } from 'react-dropzone'

import classNames from 'classnames'
import { Button, Icon } from 'component-library-next'

import letter from './letter.svg'

import './style.scss'

export type UploadLetterDropzoneProps = {
  onUpload: (files: File[]) => void
}

export const UploadLetterDropzone = ({ onUpload }: UploadLetterDropzoneProps) => {
  const dropzoneRef = useRef<DropzoneRef>(null)
  return (
    <Dropzone
      noClick={true}
      accept={{
        'application/pdf': ['.pdf'],
        'application/msword': ['.doc'],
        'application/vnd.openxmlformats': ['.docx'],
        'image/jpeg': ['.jpg', '.jpeg'],
        'image/png': ['.png']
      }}
      ref={dropzoneRef}
      onDrop={(acceptedFiles) => onUpload(acceptedFiles)}
    >
      {({ isDragActive, getRootProps, getInputProps }) => {
        return (
          <div {...getRootProps()}>
            <div
              className={classNames([
                'upload-letter-dropzone',
                `file-uploader ${isDragActive ? 'active-dropzone' : ''}`
              ])}
              onClick={() => {
                dropzoneRef.current?.open()
              }}
            >
              <div className='upload-letter-dropzone__grid'>
                <div className={'upload-file-dropzone__icons'}>
                  <Button shape={Button.shapes.Circle} color={Button.colors.premium}>
                    <Icon alt='add' name={Icon.names.plus} />
                  </Button>
                </div>
                <div id={'upload-letter-dropzone__box-text'}>
                  <p>
                    <b>Kopie Ihres Anwaltsschreibens</b>
                  </p>
                  <p>
                    Laden Sie hier die Kopie Ihres Anwaltsschreibens an die Gegenseite zwecks
                    Kenntnisnahme durch Mandanten hoch.
                  </p>
                  <p>Unterstützte Formate: PDF, DOC, DOCX, JPG, JPEG, PNG</p>
                </div>
                <div className={'upload-file-dropzone__icons'}>
                  <img alt='letter' src={letter} />
                </div>
              </div>
            </div>
            <input {...getInputProps()} />
          </div>
        )
      }}
    </Dropzone>
  )
}
